import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  cta?: ReactNode;
}

export function EmptyState({ icon, title, description, cta }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6 text-secondary-text">
      {icon ? <div className="mb-4 text-4xl">{icon}</div> : null}
      <div className="text-heading-2 text-main-text mb-1">{title}</div>
      {description ? <div className="text-body mb-6">{description}</div> : null}
      {cta}
    </div>
  );
}
